import { useCallback } from 'react';

import { useMutRef } from '@toolbox/hooks';

import type { BaseAction } from '../reducer/types';
import type { Middleware } from './useEnhancedReducer';

export const useEventMiddleware = <A extends BaseAction, S>(
  on: (action: A, getState: () => S) => void,
): Middleware<S, A> => {
  const onRef = useMutRef(on);

  return useCallback(
    ({ getState }) =>
      (next) =>
      (action) => {
        const result = next(action);
        try {
          onRef.current(action as A, getState);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
        return result;
      },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};
